module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jf272"))).then(() => parcelRequire('ikE14'));